import React, { useContext } from 'react'
import styled from '@emotion/styled'
import { ModalContext } from 'providers/Modal'
import HelpLink from './HelpLink'
import { Link, Arrow } from './common/createStyledElement'
import { setBackground, setDimensions } from './common/createStyle'
import heroStyles from 'styles/hero.module.scss'
import 'styles/sixMillion.scss'

const LogoContainer = styled.div`
  background-size: 100% !important;
  ${setBackground}
  ${setDimensions}
`
const RenderLogo = ({ domainLogo, logoDimension }) => (
  <LogoContainer backgroundUrl={domainLogo} dimensions={logoDimension} />
)

const Logo = props => {
  return props.showSixMillion === 'Y' ? (
    <div className="logoSixMillionWrap">
      <RenderLogo {...props} />
      <div className="sixMillion" />
    </div>
  ) : (
    <RenderLogo {...props} />
  )
}

const LoginLink = ({ onClick, topNavRightColor }) => (
  <Link
    data-testid="login_link"
    onClick={onClick}
    href="javascript:void(0)"
    className={heroStyles.login}
    colorCode={topNavRightColor}
  >
    Login
    <Arrow colorCode={topNavRightColor} />
  </Link>
)

const Nav = ({ children }) => (
  <div className={heroStyles.topRightNav}>{children}</div>
)

function TopNav(props) {
  const { setActive } = useContext(ModalContext)
  return (
    <div className={heroStyles.topNavWrap}>
      <Logo {...props} />
      <Nav>
        <LoginLink
          onClick={() => setActive('login')}
          topNavRightColor={props.topNavRightColor}
        />
        <HelpLink topNavRightColor={props.topNavRightColor} />
      </Nav>
    </div>
  )
}

export default TopNav
